{
  "version": "1.2.6",
  "objects": {
    "7431911414816911943": {
      "type": "frame",
      "id": "7431911414816911943",
      "z": 7266,
      "textContent": "",
      "left": 4040.8528306907856,
      "top": 639.7036768266822,
      "width": 400,
      "height": 500,
      "scaleX": 1.597283698016738,
      "scaleY": 1.4910859375000005,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1Ux",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "user",
      "layoutGap": 30,
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7435250780336444350": {
      "type": "frame",
      "id": "7435250780336444350",
      "z": -280,
      "textContent": "Frame 45",
      "left": 4060.8528306907856,
      "top": 659.7036768266822,
      "width": 400,
      "height": 500,
      "scaleX": 0.44999999999999885,
      "scaleY": 1.4064095919878874,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7431911414816911943",
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7435250706516579166": {
      "type": "frame",
      "id": "7435250706516579166",
      "z": 48,
      "textContent": "Frame 36",
      "left": 4060.8528306907856,
      "top": 1152.732134572645,
      "width": 400,
      "height": 500,
      "scaleX": 0.45,
      "scaleY": 0.163,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7435250780336444350",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a7",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 20,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7435250706503424166": {
      "type": "wireframe",
      "id": "7435250706503424166",
      "z": 288,
      "top": 1152.732134572645,
      "left": 4061.3528306907856,
      "width": 240,
      "height": 40,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7435250706516579166",
      "layoutPosition": "a0",
      "wireframeName": "dropdown",
      "fill": "#808080",
      "itemsData": {
        "7429334000933159007": {
          "id": "7429334000933159007",
          "value": "Item",
          "item_position": 1000000
        },
        "7429334000941708440": {
          "id": "7429334000941708440",
          "value": "Item",
          "item_position": 0
        },
        "7429334000942037671": {
          "id": "7429334000942037671",
          "value": "Item",
          "item_position": 2000000
        }
      },
      "textColor": "#333333",
      "style": "underlined",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "CATEGORY 3",
        "iconRight": { "prefix": "fas", "iconName": "angle-down" }
      }
    },
    "7435250706502893285": {
      "type": "wireframe",
      "id": "7435250706502893285",
      "z": 320,
      "top": 1202.732134572645,
      "left": 4061.8528306907856,
      "width": 238.66666666666606,
      "height": 42,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7435250706516579166",
      "layoutPosition": "a1",
      "wireframeName": "slider",
      "fill": "#808080",
      "textColor": "#333333",
      "fontSize": 14,
      "label": {},
      "placeholder": {},
      "setDimension": true,
      "progress": 0.4999999999999999
    },
    "7435250706505589906": {
      "type": "frame",
      "id": "7435250706505589906",
      "z": 64,
      "textContent": "Frame 134",
      "left": 4060.8528306907856,
      "top": 966.9291216986543,
      "width": 400,
      "height": 500,
      "scaleX": 0.45,
      "scaleY": 0.3147890625,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7435250780336444350",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a3",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 20,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7435250706511538560": {
      "type": "wireframe",
      "id": "7435250706511538560",
      "z": 128,
      "top": 1016.9291216986543,
      "left": 4060.8528306907856,
      "width": 66.2548828125,
      "height": 24,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7435250706505589906",
      "layoutPosition": "a1",
      "wireframeName": "radioButton",
      "fill": "#808080",
      "textColor": "#333333",
      "componentState": "filled",
      "uiState": "enabled",
      "fontSize": 14,
      "label": { "value": "Label", "position": "right" },
      "placeholder": {}
    },
    "7435250706503275379": {
      "type": "wireframe",
      "id": "7435250706503275379",
      "z": 144,
      "top": 1054.9291216986544,
      "left": 4060.8528306907856,
      "width": 66.2548828125,
      "height": 24,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7435250706505589906",
      "layoutPosition": "a2",
      "wireframeName": "radioButton",
      "fill": "#808080",
      "textColor": "#333333",
      "componentState": "filled",
      "uiState": "enabled",
      "fontSize": 14,
      "label": { "value": "Label", "position": "right" },
      "placeholder": {}
    },
    "7435250706512324858": {
      "type": "wireframe",
      "id": "7435250706512324858",
      "z": 160,
      "top": 1092.9291216986544,
      "left": 4060.8528306907856,
      "width": 66.2548828125,
      "height": 24,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7435250706505589906",
      "layoutPosition": "a3",
      "wireframeName": "radioButton",
      "fill": "#808080",
      "textColor": "#333333",
      "componentState": "filled",
      "uiState": "enabled",
      "fontSize": 14,
      "label": { "value": "Label", "position": "right" },
      "placeholder": {}
    },
    "7435250706517102163": {
      "type": "wireframe",
      "id": "7435250706517102163",
      "z": 176,
      "top": 966.9291216986543,
      "left": 4060.8528306907856,
      "width": 240,
      "height": 40,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7435250706505589906",
      "wireframeName": "dropdown",
      "fill": "#808080",
      "itemsData": {
        "7429334000933159007": {
          "id": "7429334000933159007",
          "value": "Item",
          "item_position": 1000000
        },
        "7429334000941708440": {
          "id": "7429334000941708440",
          "value": "Item",
          "item_position": 0
        },
        "7429334000942037671": {
          "id": "7429334000942037671",
          "value": "Item",
          "item_position": 2000000
        }
      },
      "textColor": "#333333",
      "style": "underlined",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "CATEGORY 2",
        "iconRight": { "prefix": "fas", "iconName": "angle-down" }
      }
    },
    "7435250706490154043": {
      "type": "frame",
      "id": "7435250706490154043",
      "z": 96,
      "textContent": "Frame 133",
      "left": 4060.8528306907856,
      "top": 794.5206400746637,
      "width": 400,
      "height": 500,
      "scaleX": 0.45,
      "scaleY": 0.288,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7435250780336444350",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a2",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 20,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7435250706488030153": {
      "type": "wireframe",
      "id": "7435250706488030153",
      "z": 192,
      "top": 844.5206400746637,
      "left": 4060.8528306907856,
      "width": 66.2548828125,
      "height": 24,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7435250706490154043",
      "layoutPosition": "a1",
      "wireframeName": "checkbox",
      "fill": "#808080",
      "textColor": "#333333",
      "componentState": "checkbox",
      "uiState": "enabled",
      "fontSize": 14,
      "label": { "value": "Label", "position": "right" },
      "placeholder": {}
    },
    "7435250706488554224": {
      "type": "wireframe",
      "id": "7435250706488554224",
      "z": 208,
      "top": 882.5206400746637,
      "left": 4060.8528306907856,
      "width": 66.2548828125,
      "height": 24,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7435250706490154043",
      "layoutPosition": "a2",
      "wireframeName": "checkbox",
      "fill": "#808080",
      "textColor": "#333333",
      "componentState": "checkbox",
      "uiState": "enabled",
      "fontSize": 14,
      "label": { "value": "Label", "position": "right" },
      "placeholder": {}
    },
    "7435250706496257843": {
      "type": "wireframe",
      "id": "7435250706496257843",
      "z": 224,
      "top": 920.5206400746637,
      "left": 4060.8528306907856,
      "width": 66.2548828125,
      "height": 24,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7435250706490154043",
      "layoutPosition": "a3",
      "wireframeName": "checkbox",
      "fill": "#808080",
      "textColor": "#333333",
      "componentState": "checkbox",
      "uiState": "enabled",
      "fontSize": 14,
      "label": { "value": "Label", "position": "right" },
      "placeholder": {}
    },
    "7435250706493513440": {
      "type": "wireframe",
      "id": "7435250706493513440",
      "z": 272,
      "top": 794.5206400746637,
      "left": 4060.8528306907856,
      "width": 240,
      "height": 40,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7435250706490154043",
      "layoutPosition": "a0l",
      "wireframeName": "dropdown",
      "fill": "#808080",
      "itemsData": {
        "7429334000933159007": {
          "id": "7429334000933159007",
          "value": "Item",
          "item_position": 1000000
        },
        "7429334000941708440": {
          "id": "7429334000941708440",
          "value": "Item",
          "item_position": 0
        },
        "7429334000942037671": {
          "id": "7429334000942037671",
          "value": "Item",
          "item_position": 2000000
        }
      },
      "textColor": "#333333",
      "style": "underlined",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "CATEGORY 1",
        "iconRight": { "prefix": "fas", "iconName": "angle-down" }
      }
    },
    "7435250706507132527": {
      "type": "wireframe",
      "id": "7435250706507132527",
      "z": 112,
      "top": 1262.6406161966356,
      "left": 4060.8528306907856,
      "width": 240,
      "height": 40,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7435250780336444350",
      "layoutPosition": "a7V",
      "wireframeName": "dropdown",
      "fill": "#808080",
      "itemsData": {
        "7429334000933159007": {
          "id": "7429334000933159007",
          "value": "Item",
          "item_position": 1000000
        },
        "7429334000941708440": {
          "id": "7429334000941708440",
          "value": "Item",
          "item_position": 0
        },
        "7429334000942037671": {
          "id": "7429334000942037671",
          "value": "Item",
          "item_position": 2000000
        }
      },
      "textColor": "#333333",
      "style": "underlined",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "CATEGORY 4",
        "iconLeft": null,
        "iconRight": { "prefix": "fas", "iconName": "angle-right" }
      }
    },
    "7435250706487698555": {
      "type": "wireframe",
      "id": "7435250706487698555",
      "z": 240,
      "top": 1321.0490978206262,
      "left": 4060.8528306907856,
      "width": 179.30702506293255,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7435250780336444350",
      "layoutPosition": "a8",
      "wireframeName": "button",
      "fill": "#808080",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Show more results" },
      "setDimension": true
    },
    "7435250706491297306": {
      "type": "shape",
      "id": "7435250706491297306",
      "z": 256,
      "shapeName": "text",
      "textContent": "<p>Filters</p>",
      "left": 4060.8528306907856,
      "top": 728.1121584506731,
      "width": 48.22222222222222,
      "height": 29.555555555555554,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.2857142857142858,
      "scaleY": 1.2857142857142858,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 18,
      "angle": 0,
      "container": "7435250780336444350",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false
    },
    "7435250706515570209": {
      "type": "frame",
      "id": "7435250706515570209",
      "z": 304,
      "textContent": "Frame 24",
      "left": 4060.8528306907856,
      "top": 659.7036768266822,
      "width": 400,
      "height": 500,
      "scaleX": 0.34067271990507153,
      "scaleY": 0.08000000000000046,
      "fill": "#DC5686",
      "opacity": 0.05,
      "container": "7435250780336444350",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 100,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7431911627863494075": {
      "type": "frame",
      "id": "7431911627863494075",
      "z": 4385,
      "textContent": "Frame 142",
      "left": 4270.852830690785,
      "top": 659.7036768266822,
      "width": 400,
      "height": 500,
      "scaleX": 0.9722836980167403,
      "scaleY": 1.4110859375000004,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7431911414816911943",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a4",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 20,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "right",
      "layoutAlignVertical": "top"
    },
    "7431911627864001768": {
      "type": "wireframe",
      "id": "7431911627864001768",
      "z": 4386,
      "top": 719.7036768266822,
      "left": 4479.766309897481,
      "width": 240,
      "height": 40,
      "scaleX": 0.75,
      "scaleY": 0.75,
      "container": "7431911627863494075",
      "layoutPosition": "a0UV",
      "wireframeName": "dropdown",
      "fill": "#CACACA",
      "itemsData": {
        "7429334000933159007": {
          "id": "7429334000933159007",
          "value": "Item",
          "item_position": 1000000
        },
        "7429334000941708440": {
          "id": "7429334000941708440",
          "value": "Item",
          "item_position": 0
        },
        "7429334000942037671": {
          "id": "7429334000942037671",
          "value": "Item",
          "item_position": 2000000
        }
      },
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "text",
        "value": "Sort: Price - low to high",
        "iconRight": { "prefix": "fas", "iconName": "angle-down" }
      }
    },
    "7431911627849760063": {
      "type": "wireframe",
      "id": "7431911627849760063",
      "z": 4387,
      "top": 659.7036768266822,
      "left": 4270.852830690785,
      "width": 388.91347920669614,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911627863494075",
      "layoutPosition": "a0",
      "wireframeName": "searchBar",
      "fill": "#CACACA",
      "itemsData": {
        "7429333925299645014": {
          "id": "7429333925299645014",
          "value": "Item",
          "item_position": 2000000
        },
        "7429333925306962229": {
          "id": "7429333925306962229",
          "value": "Item",
          "item_position": 0
        },
        "7429333925307777585": {
          "id": "7429333925307777585",
          "value": "Item",
          "item_position": 1000000
        }
      },
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Search",
        "iconLeft": { "prefix": "fas", "iconName": "magnifying-glass" }
      },
      "setDimension": true
    },
    "7431911627861334629": {
      "type": "frame",
      "id": "7431911627861334629",
      "z": 4388,
      "textContent": "Frame 24",
      "left": 4273.939614693442,
      "top": 769.7036768266822,
      "width": 400,
      "height": 500,
      "scaleX": 0.9645667380100963,
      "scaleY": 1.1870859375000005,
      "fill": "#DC5686",
      "opacity": 0.05,
      "container": "7431911627863494075",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0V",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 100,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    }
  }
}
